import { render, staticRenderFns } from "./Domori.vue?vue&type=template&id=54cb5047&scoped=true"
import script from "./Domori.vue?vue&type=script&lang=js"
export * from "./Domori.vue?vue&type=script&lang=js"
import style0 from "./Domori.vue?vue&type=style&index=0&id=54cb5047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb5047",
  null
  
)

export default component.exports